module.exports = __webpack_public_path__ + "static/media/guitar-head.ee41f82b.jpg";